const getDeviceMode = (rootState) => rootState.ws.view.deviceMode;

export default getDeviceMode;
